module.exports = __webpack_public_path__ + "static/media/DhruvProfilePicture.fdeb8108.png";